<template>
  <a-spin tip="加载中..." :spinning="loading">
    <div class="center-box">
      <div class="searchBox">
        <a-space class="mr-10">
          <a-input
            v-model:value="queryParams.searchKey"
            class="keyword"
            allow-clear
            placeholder="请输入关键字"
            @pressEnter="changePage"
          />
        </a-space>
        <a-button type="primary" @click="changePage">查询</a-button>
      </div>

      <a-table
        :data-source="waylinesData.data"
        :pagination="paginationProp"
        align="center"
        class="mt10"
        row-key="id"
        @change="refreshData"
        :scroll="{ y: 550 }"
      >
        <a-table-column align="center" key="name" title="航线名称" data-index="name" />
        <a-table-column align="center" key="payload_model_keys" title="负载" data-index="payload_model_keys">
          <template #default="{ record }">
            {{ record.payload_model_keys.toString() }}
          </template>
        </a-table-column>
        <a-table-column align="center" key="update_time" title="更新时间" data-index="update_time">
          <template #default="{ record }">
            {{ moment(record.update_time).format('YYYY-MM-DD HH:mm:ss') }}
          </template>
        </a-table-column>
        <a-table-column align="center" key="active" title="操作">
          <template #default="{ record }">
            <a-button class="btnLink" type="link" @click="openBinding(record)">绑定算法</a-button>
          </template>
        </a-table-column>
      </a-table>

      <a-modal
        v-model:visible="isOpenAlgorithm"
        width="fit-content"
        style="min-height: 40vh"
        wrapClassName="binding-algorithm-modal"
        :mask-closable="false"
        :confirm-loading="isBindingLoading"
        @ok="bindingAlgorithm"
        @cancel="cancelBinding"
      >
        <div class="cf" style="padding: 30px 0">
          <div class="flex-display flex-justify-between flex-align-center mb10">
            <h3 class="cf">算法模型添加</h3>
            <a-button type="primary" @click="addModel">添加模型</a-button>
          </div>

          <a-space class="mr-20">
            <span>跳帧数量:</span>
            <a-input-number v-model:value="skipFrame" :min="1" />
            帧
          </a-space>
          <a-space class="mr-20">
            <span>推送频率:</span>
            <a-input-number v-model:value="pushFrequency" :min="1" />
            秒
          </a-space>
          <a-space class="mr-20">
            <span>短信推送频率:</span>
            <a-input-number v-model:value="smsPushFrequency" :min="1" />
            秒
          </a-space>
          <a-space class="mr-20">
            <span>置信度:</span>
            <a-input-number v-model:value="confThreshold" :min="0.01" :max="0.99" :step="0.01" />
          </a-space>
          <a-space>
            <span>启用AI盒子:</span>
            <a-checkbox v-model:checked="isGdd" />
          </a-space>

          <a-descriptions
            v-for="(taskItem, index) in taskList.data"
            :key="index"
            class="mt20"
            bordered
            layout="vertical"
            :column="8"
          >
            <a-descriptions-item label="模型名称">
              <a-select
                ref="select"
                v-model:value="taskItem.model_no"
                :disabled="taskItem.taskNo"
                style="width: 140px"
                @change="handleModelChange(taskItem)"
              >
                <a-select-option
                  v-for="item in modelList"
                  :key="item.modelNo"
                  :value="item.modelNo"
                  :title="item.name"
                >
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-descriptions-item>

            <a-descriptions-item label="开始算法航点">
              <a-select v-model:value="taskItem.start_point_index" style="width: 100px">
                <a-select-option v-for="item in waylineList" :key="item" :value="item">{{ item }}</a-select-option>
              </a-select>
            </a-descriptions-item>

            <a-descriptions-item label="结束算法航点">
              <a-select v-model:value="taskItem.end_point_index" style="width: 100px">
                <a-select-option v-for="item in waylineList" :key="item" :value="item">{{ item }}</a-select-option>
              </a-select>
            </a-descriptions-item>

            <a-descriptions-item label="ROI区域">
              <a-select
                v-model:value="taskItem.roi_region_id"
                style="width: 150px"
                allow-clear
                placeholder="不限区域"
              >
                <a-select-option v-for="item in roiOptions" :key="item.value" :value="item.value">
                  {{ item.label }}
                </a-select-option>
              </a-select>
            </a-descriptions-item>

            <a-descriptions-item label="动作绑定">
              <a-select
                v-model:value="taskItem.actions"
                mode="multiple"
                style="width: fit-content; min-width: 162px; color: #333"
                @change="(v: string[]) => changeAction(v, taskItem)"
              >
                <a-select-option v-for="item in aiList" :key="item.id" :value="item.id">
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-descriptions-item>

            <a-descriptions-item label="选择音频">
              <a-select
                v-model:value="taskItem.file_id"
                :disabled="!taskItem.actions?.includes('VOICE')"
                style="width: 150px"
              >
                <a-select-option v-for="item in audioList" :key="item.file_id" :value="item.file_id">
                  {{ item.file_title }}
                </a-select-option>
              </a-select>
            </a-descriptions-item>

            <a-descriptions-item label="告警阈值">
              <div class="flex-display flex-align-center flex-justify-between threshold-config-cell">
                <span>{{ getClassThresholdSummary(taskItem) }}</span>
                <a-button class="btnLink" type="link" @click="openThresholdConfig(taskItem, index)">配置</a-button>
              </div>
            </a-descriptions-item>

            <a-descriptions-item>
              <a-button type="danger" @click="deleteModel(index)">
                <template #icon>
                  <DeleteOutlined />
                </template>
              </a-button>
            </a-descriptions-item>
          </a-descriptions>
        </div>
      </a-modal>

      <a-modal
        v-model:visible="isThresholdConfigOpen"
        title="告警阈值配置"
        width="520px"
        wrapClassName="threshold-config-modal"
        :mask-closable="false"
        @ok="confirmThresholdConfig"
      >
        <div v-if="thresholdConfigList.length">
          <div v-for="item in thresholdConfigList" :key="item.label" class="threshold-config-item">
            <span class="threshold-config-label">{{ item.label }}</span>
            <div class="threshold-config-controls">
              <a-input-number
                v-model:value="item.value"
                :min="item.enabled ? 1 : 0"
                :step="1"
                :precision="0"
                :disabled="!item.enabled"
                class="threshold-input"
                @change="(value) => handleThresholdValueChange(item, value)"
              />
              <a-switch :checked="item.enabled" @change="(checked) => handleThresholdToggle(item, checked)" />
            </div>
          </div>
        </div>
        <a-empty v-else :image-style="{ height: '60px' }" description="暂无可配置标签" />
      </a-modal>
    </div>
  </a-spin>
</template>

<script lang="ts" setup>
import { computed, onMounted, reactive, ref } from 'vue'
import { DeleteOutlined } from '@ant-design/icons-vue'
import { message } from 'ant-design-vue'
import moment from 'moment'
import { getWaylineFiles, getWaylineLngLat } from '/@/api/wayline'
import {
  bindingAiAlgorithm,
  getAlgorithmModelListPageVo,
  getAudioFileList,
  getWayLineAiBindingDetail,
} from '/@/api/manage'
import { listByFlyLineFileId } from '/@/api/layer'
import { ELocalStorageKey } from '/@/types'
import { WaylineFile } from '/@/types/wayline'

interface ModelOption {
  modelNo: string
  name: string
  labelList?: string | string[]
  [key: string]: any
}

interface TaskBindingItem {
  id?: number
  taskNo?: string
  model_no: string
  modelInfo: Array<Record<string, any>>
  start_point_index: number
  end_point_index: number
  roi_region_id?: string | null
  actions?: string[]
  file_id?: string
  class_threshold_map?: Record<string, number> | string
  class_threshold_draft_map?: Record<string, number> | string
}

interface RoiOption {
  value: string
  label: string
}

interface ThresholdConfigItem {
  label: string
  value: number
  draftValue: number
  enabled: boolean
}

const DEFAULT_CLASS_THRESHOLD = 1

const queryParams = ref({
  page_num: 1,
  page_size: 10,
  algorithm_type: null,
  searchKey: null,
})

const paginationProp = reactive({
  showQuickJumper: true,
  showSizeChanger: false,
  showTotal: (total: number) => `共${total}条记录`,
  pageSize: 10,
  current: 1,
  total: 0,
})

const workspaceId = localStorage.getItem(ELocalStorageKey.WorkspaceId)!

const waylinesData = reactive({
  data: [] as WaylineFile[],
})

const taskList = reactive({
  data: [] as TaskBindingItem[],
})

const isOpenAlgorithm = ref(false)
const modelList = ref<ModelOption[]>([])
const waylineInfo = ref<any>()
const waylineList = ref<number[]>([])
const audioList = ref<any[]>([])
const roiOptions = ref<RoiOption[]>([])
const aiList = ref([
  { id: 'VOICE', name: '语音喊话' },
  { id: 'PHOTO', name: '拍照' },
  { id: 'FLASH', name: '红蓝爆闪' },
  { id: 'IR', name: '探照灯' },
])
const loading = ref(false)
const pushFrequency = ref(15)
const smsPushFrequency = ref(15)
const skipFrame = ref(1)
const confThreshold = ref(0.5)
const algorithm_source = ref<'dksl' | 'gdd'>('dksl')
const isThresholdConfigOpen = ref(false)
const currentThresholdTaskIndex = ref(-1)
const thresholdConfigList = ref<ThresholdConfigItem[]>([])

const isGdd = computed({
  get: () => algorithm_source.value === 'gdd',
  set: (val: boolean) => {
    algorithm_source.value = val ? 'gdd' : 'dksl'
  },
})

const isBindingLoading = ref(false)

onMounted(() => {
  getList()
  getModelList()
  getAudio()
})

function normalizeThresholdValue (value: any) {
  const numValue = Number(value)
  if (!Number.isFinite(numValue) || numValue < 1) return DEFAULT_CLASS_THRESHOLD
  return Math.floor(numValue)
}

function getAudio () {
  getAudioFileList(workspaceId, { page: 1, page_size: 999 }).then((res) => {
    if (res.code === 0) {
      audioList.value = res.data.list
    }
  })
}

function parseActionList (value: any) {
  if (Array.isArray(value)) return value
  if (typeof value !== 'string' || !value.trim()) return []
  try {
    const parsed = JSON.parse(value)
    return Array.isArray(parsed) ? parsed : []
  } catch {
    return []
  }
}

function parseLabelList (labelList: ModelOption['labelList']) {
  if (Array.isArray(labelList)) {
    return labelList.filter((item) => typeof item === 'string' && item)
  }
  if (typeof labelList !== 'string' || !labelList.trim()) return []
  try {
    const parsed = JSON.parse(labelList)
    return Array.isArray(parsed) ? parsed.filter((item) => typeof item === 'string' && item) : []
  } catch {
    return []
  }
}

function parseRawClassThresholdMap (value: any) {
  let mapValue = value
  if (typeof mapValue === 'string' && mapValue.trim()) {
    try {
      mapValue = JSON.parse(mapValue)
    } catch {
      mapValue = {}
    }
  }
  if (!mapValue || typeof mapValue !== 'object' || Array.isArray(mapValue)) return {}

  return Object.entries(mapValue).reduce((result, [key, itemValue]) => {
    const numValue = Number(itemValue)
    if (Number.isFinite(numValue) && numValue >= 0) {
      result[key] = Math.floor(numValue)
    }
    return result
  }, {} as Record<string, number>)
}

function normalizeClassThresholdMap (value: any, labels: string[] = []) {
  const sourceMap = parseRawClassThresholdMap(value)
  if (!labels.length) return sourceMap

  return labels.reduce((result, label) => {
    const currentValue = sourceMap[label]
    result[label] = currentValue === 0 ? 0 : normalizeThresholdValue(currentValue)
    return result
  }, {} as Record<string, number>)
}

function normalizeThresholdDraftMap (
  value: any,
  labels: string[] = [],
  fallbackMap: Record<string, number> = {}
) {
  const sourceMap = parseRawClassThresholdMap(value)
  if (!labels.length) return {}

  return labels.reduce((result, label) => {
    const currentValue = sourceMap[label]
    const fallbackValue = fallbackMap[label]
    if (Number.isFinite(currentValue) && currentValue >= 0) {
      result[label] = normalizeThresholdValue(currentValue)
    } else if (Number.isFinite(fallbackValue) && fallbackValue >= 0) {
      result[label] = normalizeThresholdValue(fallbackValue)
    } else {
      result[label] = DEFAULT_CLASS_THRESHOLD
    }
    return result
  }, {} as Record<string, number>)
}

function getModelByNo (modelNo: string) {
  return modelList.value.find((item) => item.modelNo === modelNo)
}

function getTaskLabels (taskItem: TaskBindingItem) {
  return parseLabelList(getModelByNo(taskItem.model_no)?.labelList)
}

function buildClassThresholdMapByLabels (labels: string[], value: any) {
  return normalizeClassThresholdMap(value, labels)
}

function buildClassThresholdDraftMapByLabels (
  labels: string[],
  value: any,
  fallbackMap: Record<string, number> = {}
) {
  return normalizeThresholdDraftMap(value, labels, fallbackMap)
}

function buildTaskClassThresholdMap (taskItem: TaskBindingItem) {
  return buildClassThresholdMapByLabels(getTaskLabels(taskItem), taskItem.class_threshold_map)
}

function buildTaskClassThresholdDraftMap (taskItem: TaskBindingItem) {
  const labels = getTaskLabels(taskItem)
  const thresholdMap = buildClassThresholdMapByLabels(labels, taskItem.class_threshold_map)
  return buildClassThresholdDraftMapByLabels(labels, taskItem.class_threshold_draft_map, thresholdMap)
}

function resolveTaskClassThresholdMapFromDetail (item: any) {
  if (item?.class_threshold_map) return parseRawClassThresholdMap(item.class_threshold_map)
  if (Array.isArray(item?.model_list) && item.model_list.length > 0) {
    return parseRawClassThresholdMap(item.model_list[0]?.class_threshold_map)
  }
  return {}
}

function resolveTaskClassThresholdDraftMapFromDetail (item: any) {
  if (item?.class_threshold_draft_map) return parseRawClassThresholdMap(item.class_threshold_draft_map)
  if (Array.isArray(item?.model_list) && item.model_list.length > 0) {
    return parseRawClassThresholdMap(item.model_list[0]?.class_threshold_draft_map)
  }
  return {}
}

function changeAction (value: string[], taskItem: TaskBindingItem) {
  if (!value.includes('VOICE') && taskItem.file_id) {
    taskItem.file_id = ''
  }
}

function resetBindingForm () {
  isOpenAlgorithm.value = false
  isThresholdConfigOpen.value = false
  currentThresholdTaskIndex.value = -1
  thresholdConfigList.value = []
  taskList.data = []
  roiOptions.value = []
  skipFrame.value = 1
  pushFrequency.value = 15
  smsPushFrequency.value = 15
  confThreshold.value = 0.5
}

function cancelBinding () {
  resetBindingForm()
}

function deleteModel (index: number) {
  taskList.data.splice(index, 1)
}

function getModelList () {
  getAlgorithmModelListPageVo({
    page_num: 1,
    page_size: 99,
    algorithm_type: null,
    searchKey: null,
    workspace_id: workspaceId,
  }).then((res) => {
    if (res.code === 0) {
      modelList.value = res.data.list
      taskList.data.forEach((item) => {
        item.class_threshold_map = buildTaskClassThresholdMap(item)
        item.class_threshold_draft_map = buildTaskClassThresholdDraftMap(item)
      })
    }
  })
}

function handleModelChange (taskItem: TaskBindingItem) {
  taskItem.class_threshold_map = buildTaskClassThresholdMap(taskItem)
  taskItem.class_threshold_draft_map = buildTaskClassThresholdDraftMap(taskItem)
}

function getClassThresholdSummary (taskItem: TaskBindingItem) {
  if (!taskItem.model_no) return '请先选择模型'
  const labels = getTaskLabels(taskItem)
  if (!labels.length) return '当前模型无标签可配置'
  const currentMap = buildTaskClassThresholdMap(taskItem)
  const enabledCount = labels.filter((label) => currentMap[label] !== 0).length
  return `已开启 ${enabledCount}/${labels.length} 项`
}

function openThresholdConfig (taskItem: TaskBindingItem, index: number) {
  if (!taskItem.model_no) {
    message.warning('请先选择模型')
    return
  }

  const labels = getTaskLabels(taskItem)
  if (!labels.length) {
    message.warning('当前模型无标签可配置')
    return
  }

  const currentMap = buildClassThresholdMapByLabels(labels, taskItem.class_threshold_map)
  const draftMap = buildClassThresholdDraftMapByLabels(labels, taskItem.class_threshold_draft_map, currentMap)
  currentThresholdTaskIndex.value = index
  thresholdConfigList.value = labels.map((label) => {
    const currentValue = currentMap[label]
    const draftValue = draftMap[label]
    return {
      label,
      enabled: currentValue !== 0,
      value: currentValue === 0 ? 0 : draftValue,
      draftValue,
    }
  })
  isThresholdConfigOpen.value = true
}

function confirmThresholdConfig () {
  const taskItem = taskList.data[currentThresholdTaskIndex.value]
  if (!taskItem) {
    isThresholdConfigOpen.value = false
    return
  }

  const thresholdMap = {} as Record<string, number>
  const thresholdDraftMap = {} as Record<string, number>
  thresholdConfigList.value.forEach((item) => {
    const normalizedDraftValue = normalizeThresholdValue(item.draftValue)
    thresholdDraftMap[item.label] = normalizedDraftValue
    thresholdMap[item.label] = item.enabled ? normalizeThresholdValue(item.value) : 0
  })

  taskItem.class_threshold_map = thresholdMap
  taskItem.class_threshold_draft_map = thresholdDraftMap

  isThresholdConfigOpen.value = false
}

function handleThresholdToggle (item: ThresholdConfigItem, checked: boolean) {
  if (!checked && Number(item.value) > 0) {
    item.draftValue = normalizeThresholdValue(item.value)
  }
  item.enabled = checked
  item.value = checked ? normalizeThresholdValue(item.draftValue) : 0
}

function handleThresholdValueChange (item: ThresholdConfigItem, value: number | null) {
  const normalizedValue = normalizeThresholdValue(value)
  item.draftValue = normalizedValue
  item.value = item.enabled ? normalizedValue : 0
}

function getBindingAlgorithm (flyLineId: string) {
  taskList.data = []
  getWayLineAiBindingDetail({
    fly_line_id: flyLineId,
  }).then((res) => {
    if (res.code === 0 && res.data.list.length > 0) {
      confThreshold.value = res.data.list[0].conf_threshold
      pushFrequency.value = res.data.list[0].push_frequency
      smsPushFrequency.value = res.data.list[0].sms_frequency
      algorithm_source.value = res.data.list[0].algorithm_source
      skipFrame.value = res.data.list[0].skip_frame

      res.data.list.forEach((item: any) => {
        const taskItem: TaskBindingItem = {
          model_no: item.model_no,
          modelInfo: [],
          start_point_index: item.start_point_index,
          end_point_index: item.end_point_index,
          roi_region_id: item.roi_region_id || null,
          actions: parseActionList(item.actions),
          file_id: item.file_id,
          class_threshold_map: resolveTaskClassThresholdMapFromDetail(item),
          class_threshold_draft_map: resolveTaskClassThresholdDraftMapFromDetail(item),
        }
        taskItem.class_threshold_map = buildTaskClassThresholdMap(taskItem)
        taskItem.class_threshold_draft_map = buildTaskClassThresholdDraftMap(taskItem)
        taskList.data.push(taskItem)
      })
    }
  })
}

function bindingAlgorithm () {
  const userId = localStorage.getItem(ELocalStorageKey.UserId)
  const list: any[] = []

  for (const item of taskList.data) {
    if (item.actions?.includes('VOICE') && !item.file_id) {
      message.warning('请选择音频文件')
      return
    }

    const classThresholdMap = buildTaskClassThresholdMap(item)
    item.modelInfo = []
    for (const elModel of modelList.value) {
      if (item.model_no === elModel.modelNo) {
        item.modelInfo.push({
          model_name: elModel.name,
          model_no: elModel.modelNo,
          algorithm_source: elModel.source,
          class_threshold_map: classThresholdMap,
        })
      }
    }

    list.push({
      start_point_index: item.start_point_index,
      end_point_index: item.end_point_index,
      roi_region_id: item.roi_region_id || null,
      model_list: item.modelInfo,
      actions: item.actions,
      file_id: item.file_id,
    })
  }

  isBindingLoading.value = true
  bindingAiAlgorithm({
    user_id: userId,
    fly_line_id: waylineInfo.value.id,
    skip_frame: skipFrame.value,
    push_frequency: pushFrequency.value,
    sms_frequency: smsPushFrequency.value,
    conf_threshold: confThreshold.value,
    waypoint_algorithm_list: list,
  }).then((res) => {
    if (res.code === 0) {
      resetBindingForm()
      message.success('绑定算法成功')
    }
  }).finally(() => {
    isBindingLoading.value = false
  })
}

function addModel () {
  taskList.data.push({
    model_no: '',
    modelInfo: [],
    start_point_index: 1,
    end_point_index: waylineList.value.length,
    roi_region_id: null,
    actions: [],
    class_threshold_map: {},
    class_threshold_draft_map: {},
  })
}

function getRoiList (flyLineFileId: string) {
  listByFlyLineFileId(flyLineFileId, workspaceId).then((res: any) => {
    if (res.code === 0 && res.data) {
      const options: RoiOption[] = []
      for (const roiRegionId in res.data) {
        const points = res.data[roiRegionId]
        const name = Array.isArray(points) && points.length > 0 ? points[0].name : roiRegionId
        options.push({ value: roiRegionId, label: name || roiRegionId })
      }
      roiOptions.value = options
    }
  })
}

function openBinding (wayline: any) {
  loading.value = true
  waylineInfo.value = wayline

  getWaylineLngLat(workspaceId, waylineInfo.value.id).then((res) => {
    loading.value = false
    if (res.code === 0) {
      isOpenAlgorithm.value = true
      waylineList.value = []
      if (res.data.waylines.length > 0) {
        const num = res.data.waylines.length
        for (let i = 1; i <= num; i++) {
          waylineList.value.push(i)
        }
      }
    }
  })

  getBindingAlgorithm(waylineInfo.value.id)
  getRoiList(waylineInfo.value.id)
}

function changePage () {
  queryParams.value.page_num = 1
  getList()
}

function refreshData (page: any) {
  queryParams.value.page_num = page.current
  getList()
}

function getList () {
  getWaylineFiles(workspaceId, {
    page: queryParams.value.page_num,
    page_size: queryParams.value.page_size,
    search_key: queryParams.value.searchKey,
    order_by: 'update_time desc',
    type: 'point',
  }).then((res) => {
    if (res.code !== 0) return
    waylinesData.data = [...res.data.list]
    paginationProp.total = res.data.pagination.total
    paginationProp.current = res.data.pagination.page
  })
}
</script>

<style lang="scss" scoped>
.btnLink {
  margin: 0;
  padding: 0;
  height: fit-content;
}

.threshold-config-cell {
  color: #fff;
  gap: 12px;
  min-width: 220px;
  padding: 6px 0;
}

.threshold-config-cell span {
  color: #fff;
  font-size: 14px;
  line-height: 22px;
}

.threshold-config-cell .btnLink {
  color: #49a6ff;
  font-weight: 500;
}

.threshold-config-item {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 180px;
  align-items: center;
  column-gap: 16px;
  margin-bottom: 4px;
  padding: 4px 0;
}

.threshold-config-item:last-child {
  margin-bottom: 0;
}

.threshold-config-label {
  color: #fff;
  font-size: 15px;
  line-height: 22px;
  font-weight: 500;
  word-break: break-all;
}

.threshold-config-controls {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  min-width: 0;
}

.threshold-input {
  width: 118px;
  flex: 0 0 118px;
}

:deep(.binding-algorithm-modal .ant-descriptions-item-label > span) {
  color: rgba(255, 255, 255, 0.88);
}

:deep(.binding-algorithm-modal .ant-descriptions-item-content) {
  color: #fff;
}

:deep(.threshold-config-modal .ant-modal-header),
:deep(.threshold-config-modal .ant-modal-content),
:deep(.threshold-config-modal .ant-modal-body),
:deep(.threshold-config-modal .ant-modal-footer) {
  background: #0a1c31;
}

:deep(.threshold-config-modal .ant-modal-header) {
  border-bottom: 1px solid rgba(73, 166, 255, 0.18);
}

:deep(.threshold-config-modal .ant-modal-title),
:deep(.threshold-config-modal .ant-modal-close-x),
:deep(.threshold-config-modal .ant-empty-description) {
  color: #fff;
}

:deep(.threshold-config-modal .ant-modal-body) {
  padding: 22px 24px 18px;
}

:deep(.threshold-config-modal .ant-modal-footer) {
  border-top: 1px solid rgba(73, 166, 255, 0.12);
}

:deep(.threshold-config-modal .ant-input-number) {
  background: rgba(9, 30, 52, 0.96);
  border-color: rgba(73, 166, 255, 0.35);
}

:deep(.threshold-config-modal .ant-input-number-input) {
  color: #fff;
}

:deep(.threshold-config-modal .ant-input-number-disabled) {
  background: rgba(255, 255, 255, 0.06);
  border-color: rgba(255, 255, 255, 0.12);
}

:deep(.threshold-config-modal .ant-input-number-disabled .ant-input-number-input) {
  color: rgba(255, 255, 255, 0.4);
}

:deep(.threshold-config-modal .ant-switch) {
  flex: 0 0 auto;
}
</style>
